import * as React from 'react';
import type { SVGProps } from 'react';
const SvgESignPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <rect width={32} height={32} fill="#F43FE2" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M7 17.934c.907-.062 1.722-.205 2.596-.53 2.039-.759 4.214-1.854 5.802-3.533.442-.468 1.04-1.343.75-2.098-.216-.566-.878-.819-1.381-.766-2.097.22-2.952 3.108-2.723 5.126.352 3.092 3.734 3.391 5.789 2.27 1.51-.825 2.57-2.537 3.47-4.078.062-.107.113-.227.195-.315.027-.027.01.083 0 .122-.117.508-.285.999-.39 1.51-.135.65-.275 1.417.075 2.02.368.634 1.047.955 1.697.787.792-.204 1.553-.839 2.12-1.482M9 23c2.524-.6 5.018-.942 7.627-.991 1.834-.035 3.62.01 5.373.529M19 10c.3-.414.626-.735 1-1"
    />
  </svg>
);
export default SvgESignPdf;
